import * as R from 'ramda';

const initialState = {
  providers: {},
  providersLoaded: false,
  loadingProviders: false,
  loadingConfig: false,
  saving: false,
  error: '',
  statusMessage: '',
  selectedProvider: '',
  selectedModel: '',
  inheritCompanyDefaults: false,
  initialSelection: {
    provider: '',
    model: '',
    inheritCompanyDefaults: false,
  },
  companyConfig: null,
  partnerConfig: null,
  effectiveConfig: null,
};

const deriveSelection = ({ payload = {}, args = [], state }) => {
  const { companyConfig, partnerConfig, effectiveConfig } = payload;
  const partnerId = R.path([0, 'partnerId'], args);
  const isPartner = Boolean(partnerId);
  const inheritCompanyDefaults = isPartner && !partnerConfig;
  const baseConfig = partnerConfig || companyConfig || effectiveConfig || {};
  const provider = baseConfig.llm || state.selectedProvider || 'openai';
  const model = baseConfig.model || state.selectedModel || '';

  return {
    companyConfig,
    partnerConfig,
    effectiveConfig,
    selectedProvider: inheritCompanyDefaults ? (companyConfig?.llm || effectiveConfig?.llm || provider) : provider,
    selectedModel: inheritCompanyDefaults ? (companyConfig?.model || effectiveConfig?.model || model) : model,
    inheritCompanyDefaults,
    initialSelection: {
      provider,
      model,
      inheritCompanyDefaults,
    },
    error: '',
    statusMessage: '',
    loadingConfig: false,
    saving: false,
  };
};

export default function llmSettingsReducer(state = initialState, action = {}) {
  const { type, payload = {} } = action;
  switch (type) {
    case 'genAI_llmSettings_getProviders_STARTED':
      return {
        ...state,
        loadingProviders: true,
        error: '',
      };
    case 'genAI_llmSettings_getProviders_SUCCESS': {
      const nextProviders = payload.providers || {};
      let nextSelectedModel = state.selectedModel;
      if (state.selectedProvider && nextProviders[state.selectedProvider]) {
        const providerModels = Object.keys(nextProviders[state.selectedProvider]);
        if (providerModels.length && !providerModels.includes(state.selectedModel)) {
          nextSelectedModel = providerModels[0];
        }
      }
      return {
        ...state,
        loadingProviders: false,
        providers: nextProviders,
        providersLoaded: true,
        selectedModel: nextSelectedModel,
        error: '',
      };
    }
    case 'genAI_llmSettings_getProviders_ERROR':
      return {
        ...state,
        loadingProviders: false,
        error: payload?.message || 'Unable to load providers',
      };
    case 'genAI_llmSettings_getConfig_STARTED':
      return {
        ...state,
        loadingConfig: true,
        error: '',
        statusMessage: '',
      };
    case 'genAI_llmSettings_getConfig_SUCCESS':
      return {
        ...state,
        ...deriveSelection({ payload, args: action.args, state }),
      };
    case 'genAI_llmSettings_getConfig_ERROR':
      return {
        ...state,
        loadingConfig: false,
        error: payload?.message || 'Unable to load LLM settings',
      };
    case 'genAI_llmSettings_saveConfig_STARTED':
      return {
        ...state,
        saving: true,
        statusMessage: '',
        error: '',
      };
    case 'genAI_llmSettings_saveConfig_SUCCESS':
      return {
        ...state,
        ...deriveSelection({ payload, args: action.args, state }),
        statusMessage: 'LLM settings saved',
      };
    case 'genAI_llmSettings_saveConfig_ERROR':
      return {
        ...state,
        saving: false,
        error: payload?.message || 'Unable to save LLM settings',
      };
    case 'genAI_llmSettings_updateSelection': {
      const nextState = { ...state, statusMessage: '', error: '' };
      const nextPayload = { ...payload };
      if (Object.prototype.hasOwnProperty.call(nextPayload, 'inheritCompanyDefaults')) {
        nextState.inheritCompanyDefaults = nextPayload.inheritCompanyDefaults;
      }
      if (nextPayload.provider) {
        const providerModels = Object.keys(state.providers[nextPayload.provider] || {});
        nextState.selectedProvider = nextPayload.provider;
        if (!providerModels.includes(state.selectedModel)) {
          nextState.selectedModel = providerModels[0] || '';
        }
      }
      if (nextPayload.model) {
        nextState.selectedModel = nextPayload.model;
      }
      if (nextPayload.provider && nextPayload.model === undefined) {
        const providerModels = Object.keys(state.providers[nextPayload.provider] || {});
        if (providerModels.length && !providerModels.includes(nextState.selectedModel)) {
          nextState.selectedModel = providerModels[0];
        }
      }
      if (
        Object.prototype.hasOwnProperty.call(nextPayload, 'inheritCompanyDefaults')
        && nextPayload.inheritCompanyDefaults === false
        && state.inheritCompanyDefaults
      ) {
        nextState.selectedProvider = state.companyConfig?.llm || state.effectiveConfig?.llm || state.selectedProvider;
        nextState.selectedModel = state.companyConfig?.model || state.effectiveConfig?.model || state.selectedModel;
      }
      return nextState;
    }
    default:
      return state;
  }
}
